import React from 'react';
import styled from 'styled-components';

const StPopupContainer = styled.span`
    bottom: 20px;
`;

const StArrow = styled.span`
    left: 100px;
`;

type Props = {
    readonly description?: string;
};

export default class ProductSalesStateDescriptionPopup extends React.Component<Props> {
    render() {
        return (
            <StPopupContainer className="default-dd details-dropdown">
                <StArrow className="active-arrow" />
                <span>{this.props.description}</span>
            </StPopupContainer>
        );
    }
}
